import {ImageField, isFilled, KeyTextField} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next'
import {Gradient} from 'src/common/Gradient'
import {Icon} from 'src/common/Icon'

type LogoBarV2Props = {
  logos: ImageField[]
  title: KeyTextField
  disableFade?: boolean
}

/**
 * Component for "LogoBar" Slices.
 */
export const LogoBarV2 = ({logos, title, disableFade = false}: LogoBarV2Props): JSX.Element => {
  return (
    <div className="relative flex h-auto w-full max-w-full scroll-mt-16 flex-col gap-6 md:mt-6 md:h-[64px] md:flex-row md:items-center md:gap-[18px] md:pl-5">
      {isFilled.keyText(title) && (
        <div className="flex items-center justify-center max-md:h-[38px]">
          <h3 className="text-detail text-center uppercase text-moss-white md:min-w-[394px] md:text-start md:text-[12px] md:font-semibold md:leading-4 md:tracking-[.72px]">
            {title}
          </h3>
        </div>
      )}
      <div className="group relative flex h-[43px] w-full max-w-full overflow-hidden">
        {!disableFade && <Gradient fromColor="Dark Green" side="left" />}
        <div className="absolute left-0 top-0 flex h-[43px] w-full select-none overflow-hidden">
          <div className="group-hover:pause-animation flex w-max shrink-0 animate-[slideInfinite_18s_linear_infinite] items-center">
            {logos.map((logo, i) => (
              <PrismicNextImage key={'0-' + i} field={logo} className="h-[48px] max-h-[48px] w-[144px] max-w-[144px]" />
            ))}
          </div>
          <div className="group-hover:pause-animation flex w-max shrink-0 animate-[slideInfinite_18s_linear_infinite] items-center">
            {logos.map((logo, i) => (
              <PrismicNextImage key={'1-' + i} field={logo} className="h-[48px] max-h-[48px] w-[144px] max-w-[144px]" />
            ))}
          </div>
        </div>
        {!disableFade && <Gradient fromColor="Dark Green" side="right" />}
      </div>
      <Icon name="corner" className="absolute left-0 top-0 h-[5px] w-[5px] text-moss-white/[70%]" />
      <Icon name="corner" className="absolute right-0 top-0 h-[5px] w-[5px] scale-x-[-1] text-moss-white/[70%]" />
      <Icon
        name="corner"
        className="absolute right-0 h-[5px] w-[5px] rotate-180 text-moss-white/[70%] max-md:top-[33px] md:bottom-0"
      />
      <Icon
        name="corner"
        className="absolute left-0 h-[5px] w-[5px] scale-y-[-1] text-moss-white/[70%] max-md:top-[33px] md:bottom-0"
      />
    </div>
  )
}
